/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Dose_PendingInputs */

const en_us2_plan_dose_pending = /** @type {(inputs: Plan_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working out the dose…`)
};

const pt_br2_plan_dose_pending = /** @type {(inputs: Plan_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando a dose…`)
};

const es_419_plan_dose_pending = /** @type {(inputs: Plan_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando la dosis…`)
};

const pt_pt2_plan_dose_pending = /** @type {(inputs: Plan_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A calcular a dose…`)
};

const fr_fr2_plan_dose_pending = /** @type {(inputs: Plan_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul de la dose…`)
};

const de_de2_plan_dose_pending = /** @type {(inputs: Plan_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosis wird berechnet…`)
};

const it_it2_plan_dose_pending = /** @type {(inputs: Plan_Dose_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolo la dose…`)
};

/**
* | output |
* | --- |
* | "Working out the dose…" |
*
* @param {Plan_Dose_PendingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_dose_pending = /** @type {((inputs?: Plan_Dose_PendingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Dose_PendingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_dose_pending(inputs)
	if (locale === "es-419") return es_419_plan_dose_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_dose_pending(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_dose_pending(inputs)
	if (locale === "de-DE") return de_de2_plan_dose_pending(inputs)
	if (locale === "it-IT") return it_it2_plan_dose_pending(inputs)
	return en_us2_plan_dose_pending(inputs)
});
export { plan_dose_pending as "plan.dose_pending" }